import { Component, Input } from '@angular/core';
import { Survey } from '../../models/survey.model';
import { Question } from '../../models/question.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QuestionService } from '../../services/question.service';

@Component({
  selector: 'app-question-modal',
  templateUrl: './question-modal.component.html',
  styleUrl: './question-modal.component.scss'
})
export class QuestionModalComponent {

  @Input() survey?: Survey;
  @Input() question?: Question;

  public formQuestion: FormGroup;
  public submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private questionService: QuestionService
  ) {
    this.formQuestion = this.formBuilder.group({
      question: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.question) {
      this.formQuestion.controls['question'].setValue(
        this.question.question
      );
    }
  }

  get f() {
    return this.formQuestion.controls;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formQuestion.invalid) {
      return;
    }

    if (this.question) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.questionService.create(
      this.survey!,
      this.formQuestion.value
    );

    if (flag) {
      this.formQuestion.reset();
      this.activeModal.close();
    }
  }

  async update() {
    this.formQuestion.value.questionId = this.question!.questionId;

    const flag = await this.questionService.update(
      this.survey!,
      this.formQuestion.value
    );

    if (flag) {
      this.formQuestion.reset();
      this.activeModal.close();
    }
  }

}
